import { render, staticRenderFns } from "./ResultsHeader.vue?vue&type=template&id=46867ea8&scoped=true&"
import script from "./ResultsHeader.vue?vue&type=script&lang=js&"
export * from "./ResultsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46867ea8",
  null
  
)

export default component.exports